import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import Login from './screens/Login/Login';
import withAuth from './hoc/withAuth';
import Dashboard from './screens/Dashboard/Dashboard';
import Game from "./screens/Game/Game";
import GameLandscape from "./screens/Game/GameLandscape";
import GameTest from "./screens/Game/GameTest";
import Debug from "./screens/Debug/Debug";
import Localize from "./components/Localize/Localize";
import CircularProgress from "@material-ui/core/CircularProgress";
import RemoteConfigService from "./components/RemoteConfigService";
import onTestEnvironment from "./hoc/onTestEnvironment";
import DownloadLanding from './components/DownloadLanding';
import DownloadLandingLite from './components/DownloadLandingLite';
import DownloadClickRedirect from './components/DownloadClickRedirect';
import Home from './components/Home';
import Invoices from "./screens/Invoices";
import Transactions from "./screens/Transactions";
import NotFound from "./screens/NotFound/NotFound";
import ConsoleViewer from "./screens/Debug/ConsoleViewer";
import FirstTimeTrigger from "./components/FirstTimeTrigger";
import BrazeService from "./components/BrazeService";
import GeoLocationHelper from "./components/Utils/GeoLocationHelper";
import { onConsent } from "./components/consent";
import { loadMetaPixel, loadAppsFlyer } from "./components/marketing";
import { BRAZE_API_KEY, BRAZE_BASE_URL } from "./env";

// Protected routes
const ProtectedDashboard = withAuth(Dashboard);

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  async componentDidMount() {
    try {
      await Localize.init(); // Init localizations
      await GeoLocationHelper.resolveCountryByIP("App"); // Resolve country by IP before remote config (campaign segmentation)
      await RemoteConfigService.init(); // Init remote config

      // Marketing / attribution SDKs only after advertisement consent (CookieYes).
      // Fires immediately if already granted (returning visitor, or consent shared
      // from the landing), or the moment the user accepts. Rendering never waits on
      // these, so declining consent does not block the app.
      onConsent(() => {
        loadMetaPixel();
        loadAppsFlyer();
        BrazeService.init(BRAZE_API_KEY, BRAZE_BASE_URL);
      });

      this.setState({ loading: false });
    } catch (error) {
      console.error("Error loading localizations:", error);
      this.setState({ loading: false });
    }
  }

  render() {
    const { loading } = this.state;

    if (loading) {
      return (
        <div className="full-screen-center">
          <CircularProgress />
        </div>
      );
    }
    
    return (
        <div>
          <ConsoleViewer/>
          <BrowserRouter>
            <div>
              <Routes>
                {/* Test */}
                <Route path="/" element={<Login />} />

                {/* Login */}
                <Route path="/login" element={<Login />} />

                {/* Game */}
                <Route path="/play" element={<Game />} />
                <Route path="/play-landscape" element={<GameLandscape />} />
                {/* Protected routes */}
                <Route path="/dashboard" element={<ProtectedDashboard />} />
                {/* Download */}
                <Route path="/download" element={<DownloadLanding />} />
                <Route path="/downloadlite" element={<DownloadLandingLite />} />
                <Route path="/download-click" element={<DownloadClickRedirect />} />
                <Route path="/home" element={<Home />} />
                {/* Invoices */}
                <Route path="/invoice/*" element={<Invoices />} />

                {/* Transactions */}
                <Route path="/transactions/*" element={<Transactions />} />

                {/* 404 */}
                <Route path="*" element={<NotFound />} />

              </Routes>
            </div>
          </BrowserRouter>
        </div>
    );
  }
}

export default App;
